module.exports = {"width":84,"height":84,"type":"png"}